var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoticeBoard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.712,
    height: 130.887,
    viewBox: "0 0 181.712 130.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notice-board",
    transform: "translate(-1190.911 -1770.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182003",
    "data-name": "Group 182003",
    transform: "translate(1232.175 1770.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241373",
    "data-name": "Path 241373",
    d: "M1898.233,1786.711h-1.483l-.019-1.18c0-.025,0-.051,0-.076l.1-10.2.016-.33a3.388,3.388,0,0,1,.1-.676,5.932,5.932,0,0,1,1.251-2.428,4.24,4.24,0,0,1,6.629,0,6,6,0,0,1,1.333,2.791h0a4.564,4.564,0,0,1,.126,1.068v1.393h-2.43l-.027-1.2a2.752,2.752,0,0,0-.657-1.757,2.143,2.143,0,0,0-3.318,0,2.747,2.747,0,0,0-.657,1.751v9.6l.041,1.254Z",
    transform: "translate(-1889.007 -1770.226)",
    fill: "#0f31ac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178266",
    "data-name": "Rectangle 178266",
    width: 90.6,
    height: 122.713,
    transform: "translate(6.434 5.915)",
    fill: "#acbcf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241374",
    "data-name": "Path 241374",
    d: "M1880.239,1953.613v-99.15h-94.776v122.592h70.908l.426-.418Z",
    transform: "translate(-1785.463 -1848.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241375",
    "data-name": "Path 241375",
    d: "M1938.2,1834.089a1.279,1.279,0,0,1,1.114,1.4v9.472h0a6.6,6.6,0,0,1-.059.883l-.04.3a3.753,3.753,0,0,1-3.449,3.308c-1.948,0-3.534-1.9-3.534-4.238v-3.78h2.456v3.78a1.079,1.079,0,1,0,2.156,0l.014-6.4v-3.486l-.024-1.232Z",
    transform: "translate(-1922.047 -1829.656)",
    fill: "#0f31ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_181981",
    "data-name": "Group 181981",
    transform: "translate(12.914 97.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181979",
    "data-name": "Group 181979",
    transform: "translate(39.998 3.479)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_758",
    "data-name": "Line 758",
    y1: 0.108,
    x2: 26.989,
    transform: "translate(0 14.013)",
    fill: "none",
    stroke: "#acbcf8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15.727
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241376",
    "data-name": "Path 241376",
    d: "M2626.6,3235.055a1.559,1.559,0,0,1-.4-1.075,11.962,11.962,0,0,1,1.563-7,7.16,7.16,0,0,1,2.358-2.576,1.06,1.06,0,0,1,.572-.2,1.107,1.107,0,0,1,.66.352,8.534,8.534,0,0,1,.426,12.233,1.086,1.086,0,0,1-.654.4.859.859,0,0,1-.784-.621c-.368-.986.334-2.034,1.067-2.789a16.26,16.26,0,0,1,3.253-2.59,3.961,3.961,0,0,1,.613.862,2.04,2.04,0,0,1,.445-1.481c.053.342.581.362.838.13s.367-.588.6-.842a2.083,2.083,0,0,1,1.982-.313,3.02,3.02,0,0,0,2.055.012,1.375,1.375,0,0,0,1.026.916",
    transform: "translate(-2620.714 -3224.204)",
    fill: "none",
    stroke: "#040c2b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181980",
    "data-name": "Group 181980",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241377",
    "data-name": "Path 241377",
    d: "M1985.489,3179.384a8.678,8.678,0,1,0,8.712,8.643A8.678,8.678,0,0,0,1985.489,3179.384Zm.066,16.388a7.711,7.711,0,1,1,7.68-7.741A7.711,7.711,0,0,1,1985.554,3195.772Z",
    transform: "translate(-1976.477 -3179.015)",
    fill: "#829cf8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11126",
    "data-name": "Ellipse 11126",
    cx: 6.397,
    cy: 6.397,
    r: 6.397,
    transform: "translate(0 9.046) rotate(-45)",
    fill: "#829cf8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_181984",
    "data-name": "Group 181984",
    transform: "translate(24.368 19.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181983",
    "data-name": "Group 181983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181982",
    "data-name": "Group 181982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241378",
    "data-name": "Path 241378",
    d: "M2141.694,2049.832a2.271,2.271,0,0,1-.75,1.835,3.206,3.206,0,0,1-2.132.635h-.676v2.644h-1.576v-7.432h2.374a3.157,3.157,0,0,1,2.056.582A2.122,2.122,0,0,1,2141.694,2049.832Zm-3.558,1.179h.518a1.728,1.728,0,0,0,1.088-.287,1,1,0,0,0,.361-.836,1.029,1.029,0,0,0-.3-.818,1.417,1.417,0,0,0-.948-.264h-.717Z",
    transform: "translate(-2136.56 -2047.397)",
    fill: "#829cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241379",
    "data-name": "Path 241379",
    d: "M2233.065,2049.651a4.032,4.032,0,0,1-.915,2.837,3.966,3.966,0,0,1-5.246,0,4.048,4.048,0,0,1-.915-2.847,4,4,0,0,1,.917-2.834,3.433,3.433,0,0,1,2.631-.978,3.383,3.383,0,0,1,2.62.986A4.043,4.043,0,0,1,2233.065,2049.651Zm-5.424,0a3.1,3.1,0,0,0,.473,1.876,1.654,1.654,0,0,0,1.413.63q1.886,0,1.886-2.506t-1.876-2.511a1.665,1.665,0,0,0-1.418.633A3.091,3.091,0,0,0,2227.641,2049.651Z",
    transform: "translate(-2219.782 -2045.829)",
    fill: "#829cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241380",
    "data-name": "Path 241380",
    d: "M2350.135,2054.946v-7.432h1.576v6.131h3.014v1.3Z",
    transform: "translate(-2335.312 -2047.397)",
    fill: "#829cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241381",
    "data-name": "Path 241381",
    d: "M2434.876,2054.946v-7.432h1.576v7.432Z",
    transform: "translate(-2414.172 -2047.397)",
    fill: "#829cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241382",
    "data-name": "Path 241382",
    d: "M2483.26,2047.287a1.605,1.605,0,0,0-1.377.668,3.109,3.109,0,0,0-.488,1.863q0,2.486,1.865,2.486a5.9,5.9,0,0,0,1.9-.391v1.322a5.266,5.266,0,0,1-2.043.381,3.116,3.116,0,0,1-2.481-.984,4.166,4.166,0,0,1-.859-2.823,4.613,4.613,0,0,1,.422-2.031,3.048,3.048,0,0,1,1.212-1.337,3.583,3.583,0,0,1,1.853-.465,5,5,0,0,1,2.176.524l-.509,1.281a8.379,8.379,0,0,0-.839-.346A2.5,2.5,0,0,0,2483.26,2047.287Z",
    transform: "translate(-2455.952 -2045.965)",
    fill: "#829cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241383",
    "data-name": "Path 241383",
    d: "M2580.115,2054.946v-7.432h1.576v7.432Z",
    transform: "translate(-2549.33 -2047.397)",
    fill: "#829cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241384",
    "data-name": "Path 241384",
    d: "M2634.053,2054.946h-4.28v-7.432h4.28v1.291h-2.7v1.632h2.516v1.291h-2.516v1.917h2.7Z",
    transform: "translate(-2595.542 -2047.397)",
    fill: "#829cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241385",
    "data-name": "Path 241385",
    d: "M2712.034,2051.45a1.921,1.921,0,0,1-.724,1.586,3.146,3.146,0,0,1-2.016.58,4.732,4.732,0,0,1-2.1-.447V2051.7a8.693,8.693,0,0,0,1.273.473,3.775,3.775,0,0,0,.953.137,1.357,1.357,0,0,0,.8-.2.679.679,0,0,0,.277-.59.653.653,0,0,0-.122-.389,1.377,1.377,0,0,0-.358-.328,9.237,9.237,0,0,0-.963-.5,4.574,4.574,0,0,1-1.022-.615,2.3,2.3,0,0,1-.543-.687,1.955,1.955,0,0,1-.2-.915,1.921,1.921,0,0,1,.668-1.551,2.778,2.778,0,0,1,1.848-.564,4.369,4.369,0,0,1,1.106.137,7.593,7.593,0,0,1,1.1.386l-.508,1.225a7.421,7.421,0,0,0-.983-.341,3.174,3.174,0,0,0-.765-.1,1.013,1.013,0,0,0-.686.208.687.687,0,0,0-.239.544.672.672,0,0,0,.1.363,1.062,1.062,0,0,0,.308.3,9.478,9.478,0,0,0,1,.521,3.979,3.979,0,0,1,1.428,1A1.948,1.948,0,0,1,2712.034,2051.45Z",
    transform: "translate(-2667.586 -2045.965)",
    fill: "#829cf8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182001",
    "data-name": "Group 182001",
    transform: "translate(8.729 51.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181987",
    "data-name": "Group 181987",
    transform: "translate(12.471 1.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181985",
    "data-name": "Group 181985"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_759",
    "data-name": "Line 759",
    x2: 63.254,
    fill: "none",
    stroke: "#acbcf8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181986",
    "data-name": "Group 181986",
    transform: "translate(0 3.791)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_760",
    "data-name": "Line 760",
    x2: 55.828,
    fill: "none",
    stroke: "#acbcf8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_181988",
    "data-name": "Group 181988"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178267",
    "data-name": "Rectangle 178267",
    width: 5.187,
    height: 5.18,
    transform: "translate(0.982 0.339)",
    fill: "#acbcf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241386",
    "data-name": "Path 241386",
    d: "M1911.237,2514.3a6.9,6.9,0,0,1,.825.4q.393.219.76.464a14.849,14.849,0,0,1,1.392,1.054l-1.128-.007c.358-.432.737-.844,1.132-1.238s.809-.771,1.243-1.127a14.507,14.507,0,0,1,1.371-1q.361-.232.746-.439a.475.475,0,1,1,.432.432q-.207.386-.439.746a14.623,14.623,0,0,1-1,1.37q-.534.651-1.127,1.243c-.395.4-.806.774-1.238,1.132l-.672.558-.455-.565a14.828,14.828,0,0,1-1.018-1.418q-.235-.373-.445-.772A6.949,6.949,0,0,1,1911.237,2514.3Z",
    transform: "translate(-1911.237 -2512.032)",
    fill: "#f6471e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181991",
    "data-name": "Group 181991",
    transform: "translate(12.471 10.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181989",
    "data-name": "Group 181989"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_761",
    "data-name": "Line 761",
    x2: 63.254,
    fill: "none",
    stroke: "#acbcf8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181990",
    "data-name": "Group 181990",
    transform: "translate(0 3.791)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_762",
    "data-name": "Line 762",
    x2: 47.777,
    fill: "none",
    stroke: "#acbcf8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_181992",
    "data-name": "Group 181992",
    transform: "translate(0 9.786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178268",
    "data-name": "Rectangle 178268",
    width: 5.187,
    height: 5.18,
    transform: "translate(0.982 0.339)",
    fill: "#acbcf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241387",
    "data-name": "Path 241387",
    d: "M1911.237,2655.3a6.935,6.935,0,0,1,.825.4q.393.219.76.465a14.721,14.721,0,0,1,1.392,1.053l-1.128-.007c.358-.432.737-.843,1.132-1.238s.809-.771,1.243-1.127a14.552,14.552,0,0,1,1.371-1q.361-.231.746-.439a6.752,6.752,0,0,1,.809-.376,6.833,6.833,0,0,1-.376.808q-.207.386-.439.746a14.6,14.6,0,0,1-1,1.371q-.534.651-1.127,1.243c-.395.4-.806.774-1.238,1.132l-.672.557-.455-.565a14.832,14.832,0,0,1-1.018-1.418q-.235-.373-.445-.772A6.928,6.928,0,0,1,1911.237,2655.3Z",
    transform: "translate(-1911.237 -2653.032)",
    fill: "#f6471e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181995",
    "data-name": "Group 181995",
    transform: "translate(12.471 20.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181993",
    "data-name": "Group 181993"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_763",
    "data-name": "Line 763",
    x2: 63.254,
    fill: "none",
    stroke: "#acbcf8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181994",
    "data-name": "Group 181994",
    transform: "translate(0 3.791)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_764",
    "data-name": "Line 764",
    x2: 60.339,
    fill: "none",
    stroke: "#acbcf8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_181996",
    "data-name": "Group 181996",
    transform: "translate(0 19.572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178269",
    "data-name": "Rectangle 178269",
    width: 5.187,
    height: 5.18,
    transform: "translate(0.982 0.339)",
    fill: "#acbcf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241388",
    "data-name": "Path 241388",
    d: "M1911.237,2796.3a6.973,6.973,0,0,1,.825.4q.393.219.76.464a14.807,14.807,0,0,1,1.392,1.054l-1.128-.007c.358-.432.737-.843,1.132-1.238s.809-.771,1.243-1.127a14.509,14.509,0,0,1,1.371-1q.361-.231.746-.439a.475.475,0,1,1,.432.432q-.207.386-.439.746a14.659,14.659,0,0,1-1,1.371q-.534.651-1.127,1.243c-.395.4-.806.774-1.238,1.133l-.672.558-.455-.565a14.8,14.8,0,0,1-1.018-1.418q-.235-.373-.445-.771A6.949,6.949,0,0,1,1911.237,2796.3Z",
    transform: "translate(-1911.237 -2794.032)",
    fill: "#f6471e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181999",
    "data-name": "Group 181999",
    transform: "translate(12.471 30.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181997",
    "data-name": "Group 181997"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_765",
    "data-name": "Line 765",
    x2: 63.254,
    fill: "none",
    stroke: "#acbcf8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181998",
    "data-name": "Group 181998",
    transform: "translate(0 3.791)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_766",
    "data-name": "Line 766",
    x2: 55.828,
    fill: "none",
    stroke: "#acbcf8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182000",
    "data-name": "Group 182000",
    transform: "translate(0 29.358)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178270",
    "data-name": "Rectangle 178270",
    width: 5.187,
    height: 5.18,
    transform: "translate(0.982 0.339)",
    fill: "#acbcf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241389",
    "data-name": "Path 241389",
    d: "M1911.237,2937.3a6.936,6.936,0,0,1,.825.4q.393.219.76.464a14.851,14.851,0,0,1,1.392,1.054l-1.128-.007c.358-.432.737-.843,1.132-1.238s.809-.771,1.243-1.127a14.507,14.507,0,0,1,1.371-1q.361-.232.746-.439a.475.475,0,1,1,.432.432q-.207.386-.439.747a14.655,14.655,0,0,1-1,1.37q-.534.65-1.127,1.243c-.395.4-.806.774-1.238,1.133l-.672.557-.455-.565a14.832,14.832,0,0,1-1.018-1.418q-.235-.373-.445-.772A6.949,6.949,0,0,1,1911.237,2937.3Z",
    transform: "translate(-1911.237 -2935.031)",
    fill: "#f6471e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182002",
    "data-name": "Group 182002",
    transform: "translate(8.729 39.003)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_767",
    "data-name": "Line 767",
    x2: 77.318,
    fill: "none",
    stroke: "#acbcf8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_768",
    "data-name": "Line 768",
    x2: 77.318,
    transform: "translate(0 4.796)",
    fill: "none",
    stroke: "#acbcf8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_241390",
    "data-name": "Path 241390",
    d: "M2836.718,3283.059h-23.442v23.023Z",
    transform: "translate(-2741.942 -3178.062)",
    fill: "#cdd7fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182004",
    "data-name": "Group 182004",
    transform: "translate(1190.911 1861.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241391",
    "data-name": "Path 241391",
    d: "M1418.721,3091.664h-2.609a1.378,1.378,0,0,0-.906-.339H1403.33a1.377,1.377,0,0,0-.906.339h-2.609a1.543,1.543,0,0,0-1.632,1.435v9.1a1.543,1.543,0,0,0,1.632,1.435h18.907a1.543,1.543,0,0,0,1.632-1.435v-9.1A1.543,1.543,0,0,0,1418.721,3091.664Zm-.742,8.451a1.543,1.543,0,0,1-1.632,1.435h-14.158a1.543,1.543,0,0,1-1.632-1.435v-4.93a1.543,1.543,0,0,1,1.632-1.435h.235a1.376,1.376,0,0,0,.906.339h11.875a1.377,1.377,0,0,0,.906-.339h.235a1.543,1.543,0,0,1,1.632,1.435Z",
    transform: "translate(-1383.797 -3091.325)",
    fill: "#829cf8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178271",
    "data-name": "Rectangle 178271",
    width: 49.56,
    height: 30.936,
    rx: 4,
    transform: "translate(0.691 7.238)",
    fill: "#0f31ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241392",
    "data-name": "Path 241392",
    d: "M1248.859,3195.618h-46.419a1.571,1.571,0,0,0-1.571,1.571v13.041a1.564,1.564,0,0,0,.88.269H1220.6v1.165a.682.682,0,0,0,.682.682h8.731a.682.682,0,0,0,.682-.682V3210.5h18.853a1.563,1.563,0,0,0,.879-.269v-13.041A1.571,1.571,0,0,0,1248.859,3195.618Z",
    transform: "translate(-1200.179 -3188.38)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178272",
    "data-name": "Rectangle 178272",
    width: 50.943,
    height: 14.868,
    rx: 7.434,
    transform: "translate(0 6.012)",
    fill: "#acbcf8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178273",
    "data-name": "Rectangle 178273",
    width: 9.416,
    height: 5.086,
    rx: 2.543,
    transform: "translate(20.763 18.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178274",
    "data-name": "Rectangle 178274",
    width: 7.644,
    height: 3.977,
    rx: 1.988,
    transform: "translate(21.649 18.887)",
    fill: "#0f31ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182008",
    "data-name": "Group 182008",
    transform: "translate(1331.222 1811.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182006",
    "data-name": "Group 182006",
    transform: "translate(0 12.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241393",
    "data-name": "Path 241393",
    d: "M3309.478,3635.97h0a.141.141,0,0,1-.124-.075l-.347-.679.01-.747.96.013-.01.747-.365.669A.14.14,0,0,1,3309.478,3635.97Z",
    transform: "translate(-3302.314 -3559.383)",
    fill: "#0f31ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241394",
    "data-name": "Path 241394",
    d: "M3216.7,2656.6l-.25,1.4a.863.863,0,0,1-.875.71,1.274,1.274,0,0,1-1.251-1.146l-1.756-17.282a3.416,3.416,0,0,1,3.49-3.34l.755.01-.051,3.935-1.217-.016a.694.694,0,0,0-.7.695l.024,14.455a.693.693,0,0,0,1.226.444.4.4,0,0,1,.469-.123l.005,0A.24.24,0,0,1,3216.7,2656.6Z",
    transform: "translate(-3212.566 -2631.083)",
    fill: "#0f31ac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178275",
    "data-name": "Rectangle 178275",
    width: 3.936,
    height: 0.253,
    transform: "translate(3.941 9.796) rotate(-89.262)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241395",
    "data-name": "Path 241395",
    d: "M3272.009,2632.5l-.059,4.589-.617-.008a.263.263,0,0,1-.26-.267l.052-4.062a.264.264,0,0,1,.267-.26Z",
    transform: "translate(-3267.012 -2626.946)",
    fill: "#0f31ac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178276",
    "data-name": "Rectangle 178276",
    width: 4.589,
    height: 0.547,
    transform: "matrix(0.013, -1, 1, 0.013, 4.444, 10.136)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241396",
    "data-name": "Path 241396",
    d: "M3275.577,2616.97l-.334,25.916,0,.267-.375,29.138-.054,4.211,0,.16-3.9-.051-3.038-.039,0-.16.43-33.349,0-.267.277-21.53.056-4.386a1.46,1.46,0,0,1,.017-.2,1.4,1.4,0,0,1,1.4-1.182l4.132.053A1.4,1.4,0,0,1,3275.577,2616.97Z",
    transform: "translate(-3264.033 -2611.129)",
    fill: "#0f31ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_178277",
    "data-name": "Rectangle 178277",
    d: "M3.2,0H60.567a0,0,0,0,1,0,0V6.4a0,0,0,0,1,0,0H3.2A3.2,3.2,0,0,1,0,3.2v0A3.2,3.2,0,0,1,3.2,0Z",
    transform: "translate(11.292 4.701) rotate(90.738)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241397",
    "data-name": "Path 241397",
    d: "M3274.79,3495.618c0,.036,0,.071,0,.107,0,.13-.006.26-.011.39,0,0,0,0,0,0a19.981,19.981,0,0,1-2.612,9.149l-.244.428a.412.412,0,0,1-.252.2.422.422,0,0,1-.114.015l-.735-.01a.424.424,0,0,1-.113-.017.413.413,0,0,1-.247-.2l-.233-.435a20,20,0,0,1-2.376-9.605c0-.036,0-.071,0-.107l3.038.039Z",
    transform: "translate(-3264.015 -3430.084)",
    fill: "#0f31ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241398",
    "data-name": "Path 241398",
    d: "M3274.4,3509.251a.149.149,0,0,1-.128-.078l-.233-.435a19.772,19.772,0,0,1-2.345-9.315l6.4.082a19.777,19.777,0,0,1-2.584,9.252l-.244.428a.148.148,0,0,1-.13.075Z",
    transform: "translate(-3267.591 -3433.709)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241399",
    "data-name": "Path 241399",
    d: "M3318.843,3507.739a19.248,19.248,0,0,1-2.492,8.461l-.132.231-.14,0,.112-8.724Z",
    transform: "translate(-3308.896 -3441.416)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241400",
    "data-name": "Path 241400",
    d: "M3299.1,2553.731l-.042,3.282-4.856-.062.042-3.281a1.094,1.094,0,0,1,1.108-1.08l2.668.034A1.094,1.094,0,0,1,3299.1,2553.731Z",
    transform: "translate(-3288.535 -2552.589)",
    fill: "#0f31ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241401",
    "data-name": "Path 241401",
    d: "M3298.095,2560.264l.039-3.015a.828.828,0,0,1,.838-.816l2.668.034a.828.828,0,0,1,.817.838l-.039,3.015Z",
    transform: "translate(-3292.159 -2556.166)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241402",
    "data-name": "Path 241402",
    d: "M3331.21,2561.11l-.035,2.748-1.894-.024.043-3.308,1.334.017A.56.56,0,0,1,3331.21,2561.11Z",
    transform: "translate(-3321.18 -2559.974)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178278",
    "data-name": "Rectangle 178278",
    width: 0.133,
    height: 4.856,
    transform: "translate(5.666 4.361) rotate(-89.261)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_182005",
    "data-name": "Group 182005",
    transform: "translate(3.632 31.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241403",
    "data-name": "Path 241403",
    d: "M3272.248,3493.435a.14.14,0,0,1,0,.031.134.134,0,0,1-.131.1h-.073l-3.936-.051-3-.039h-.074a.134.134,0,0,1-.132-.135.123.123,0,0,1,0-.031.133.133,0,0,1,.131-.1h.073l3.1.04,3.839.049h.073A.134.134,0,0,1,3272.248,3493.435Z",
    transform: "translate(-3264.898 -3459.59)",
    fill: "#0f31ac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178279",
    "data-name": "Rectangle 178279",
    width: 7.351,
    height: 0.267,
    rx: 0.133,
    transform: "matrix(1, 0.013, -0.013, 1, 0.435, 0)",
    fill: "#0f31ac"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_241404",
    "data-name": "Path 241404",
    d: "M3277.874,3021.292l-.411,31.943-.03-.008-1.3-.017.411-31.935Z",
    transform: "translate(-3271.717 -2988.746)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241405",
    "data-name": "Path 241405",
    d: "M3283.988,2628.9l-.332,25.8-1.334-.017.325-25.275a.524.524,0,0,1,.531-.518Z",
    transform: "translate(-3277.481 -2623.596)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182007",
    "data-name": "Group 182007",
    transform: "translate(1.588 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241406",
    "data-name": "Path 241406",
    d: "M3523.029,3546.264l.4,4.74-2.416.89-1.815-1.86.761-3.974Z",
    transform: "translate(-3499.507 -3464.507)",
    fill: "#db965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241407",
    "data-name": "Path 241407",
    d: "M3426.712,3576.121s-.2-1.23-.626-1.431a56.065,56.065,0,0,0-6.382,2.178s-2.125.977-.016,2.306a4.966,4.966,0,0,0,2.163.731l4.125.408s5.269.457,4.327-2.468l-.5-1.934S3428.044,3578.32,3426.712,3576.121Z",
    transform: "translate(-3406.032 -3491.149)",
    fill: "#040c2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241408",
    "data-name": "Path 241408",
    d: "M3663.273,3452.463l2.131,3.424-3.582,2.655-.676-.9-.627-4.835Z",
    transform: "translate(-3631.018 -3377.405)",
    fill: "#db965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241409",
    "data-name": "Path 241409",
    d: "M3657.936,3483.8s.426.924-.554,3.263a3.843,3.843,0,0,0-.574,1.9,6.334,6.334,0,0,1-3.92,4.037,1.285,1.285,0,0,1-1.53-.563,3.518,3.518,0,0,1-.143-2.5,56.862,56.862,0,0,0,.94-5.984s1.889,1.276,3.735-1.428C3655.889,3482.524,3656.786,3481.907,3657.936,3483.8Z",
    transform: "translate(-3622.224 -3405.29)",
    fill: "#040c2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241410",
    "data-name": "Path 241410",
    d: "M3509.5,2909.738l5.419,5.964,3.448,3.795,3.163-2.342-6.949-10.687a2.871,2.871,0,0,1-.216-2.732l5.555-12.474a17.088,17.088,0,0,0,0-14.16l-11.037.857.357,2.08,1.578,9.178-3.15,13.446A7.857,7.857,0,0,0,3509.5,2909.738Z",
    transform: "translate(-3488.582 -2841.977)",
    fill: "#040c2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241411",
    "data-name": "Path 241411",
    d: "M3509.5,2949.116l5.419,5.965-2.416-10.331,3.52-24.937-6.787-.4,1.578,9.178-3.15,13.447A7.856,7.856,0,0,0,3509.5,2949.116Z",
    transform: "translate(-3488.582 -2881.355)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241412",
    "data-name": "Path 241412",
    d: "M3452.272,2912.185l2.091,12.659,2.547,17.758,3.208-.249.937-.073-.737-18.084,3.24-27.578-9.909-.688A51.153,51.153,0,0,0,3452.272,2912.185Z",
    transform: "translate(-3437.056 -2859.498)",
    fill: "#040c2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241413",
    "data-name": "Path 241413",
    d: "M3546.945,2502.481l.793,3.817,2.327.052,4.317.1,1.735-2.032a3.5,3.5,0,0,1-.6-1.582,18.474,18.474,0,0,1-.264-2.161c-.162-2.254-.079-4.635-.079-4.635l-6.048,1.933A6.826,6.826,0,0,1,3546.945,2502.481Z",
    transform: "translate(-3525.325 -2487.358)",
    fill: "#c9885b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241414",
    "data-name": "Path 241414",
    d: "M3549.309,2380.524s-.565,8.172-6.776,7.667a1.265,1.265,0,0,1-.724-.305c-.872-.755-2.885-3.206-.519-8.451C3541.29,2379.435,3547.014,2372.137,3549.309,2380.524Z",
    transform: "translate(-3519.029 -2376.11)",
    fill: "#db965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241415",
    "data-name": "Path 241415",
    d: "M3491.224,2590.119v8.411h.3l.316-8.616Z",
    transform: "translate(-3473.471 -2574.721)",
    fill: "#262c84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241416",
    "data-name": "Path 241416",
    d: "M3436.222,2702.222l2.164,1.113,1.107.57.2.1-.027-.546-.042-.833-.1-2-.307-6.211-.1-1.934-1.958-.57-.718,7.861-.143,1.56Z",
    transform: "translate(-3422.287 -2669.638)",
    fill: "#db965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241417",
    "data-name": "Path 241417",
    d: "M3235.575,2718.094c.712,1.47,3.806,2.853,3.806,2.853l9.547,6.289a2.281,2.281,0,0,0,3.379-1.08l.343-.886.172-.444.275-.709-.316-.123-1.039-.406-2.281-.892-5.262-2.057a11.231,11.231,0,0,1-2.406-1.873,4.878,4.878,0,0,1-.784-1,11.536,11.536,0,0,0-1.566-2.007c-.51-.537-.911-.886-.911-.886a.713.713,0,0,0-.052.961l.974,1.188-1.278-.754a2.534,2.534,0,0,0-1.432-.356C3234.867,2716.02,3235.575,2718.094,3235.575,2718.094Z",
    transform: "translate(-3235.445 -2691.003)",
    fill: "#db965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241418",
    "data-name": "Path 241418",
    d: "M3401.936,2609.4l2.6.722,2.384.661.695.193.217.06.277.028-.242-6.7-.318-8.786a5.036,5.036,0,0,0-3.039,3.86Z",
    transform: "translate(-3390.381 -2579.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241419",
    "data-name": "Path 241419",
    d: "M3458.68,2709.651q.112-.573.2-1.113c.1-.631.184-1.229.246-1.79a33.283,33.283,0,0,0,.341-4.432l.2-1.14.347-2.479c-.015,1.3-.227,5.213-.187,8.245h0l.006.125.093,1.878.316.123-.275.709.027.546-.2-.1-.344.886a2.239,2.239,0,0,1-.419.689,2.27,2.27,0,0,1-1,.652C3458.3,2711.463,3458.51,2710.529,3458.68,2709.651Z",
    transform: "translate(-3442.582 -2675.953)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241420",
    "data-name": "Path 241420",
    d: "M3479.244,2817.551c1.266,1.032,4.655.978,4.655.978l8.366,1.234,2.654.392.289.042a2.28,2.28,0,0,0,2.607-2.405l-.063-.948-.031-.475-.051-.759-.339.021-1.114.07-1.545.1-.9.058-1.812.115-3.827.243a11.237,11.237,0,0,1-2.972-.682,4.877,4.877,0,0,1-1.134-.58,11.568,11.568,0,0,0-2.267-1.158c-.688-.271-1.2-.418-1.2-.418a.714.714,0,0,0,.359.893l1.384.666-1.477-.144a2.538,2.538,0,0,0-1.449.282C3477.726,2815.969,3479.244,2817.551,3479.244,2817.551Z",
    transform: "translate(-3461.732 -2782.676)",
    fill: "#db965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241421",
    "data-name": "Path 241421",
    d: "M3706.2,2674.053l.645,12-3.322.744-.149-7.932Z",
    transform: "translate(-3670.896 -2653.02)",
    fill: "#db965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241422",
    "data-name": "Path 241422",
    d: "M3699.476,2622.842l.133,3.751.165.017,7.188-2.429-3.024-8.329c-1.1-3.8-2.266-4.938-2.59-5.193A24.634,24.634,0,0,0,3699.476,2622.842Z",
    transform: "translate(-3667.149 -2594.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241423",
    "data-name": "Path 241423",
    d: "M3661.228,2708.638l.68,8.5.3,3.79,2.654.392-.246-4.354-.555-9.793Z",
    transform: "translate(-3631.677 -2683.837)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241424",
    "data-name": "Path 241424",
    d: "M3477.772,2597.552l.035.979-.038,0c0,1.587.047,3.049.109,4.34.1,1.963.564,3.736.465,4.678l-17.342-.361c.172-1.8.485-3.742.789-5.38.387-2.083.76-3.677.808-3.88a.171.171,0,0,0,0-.045q-.006-.413-.012-.8c0-.041-.012-2.627-.012-2.668-.03-2.273-.024-2.588-.015-3.151a13.912,13.912,0,0,1,.1-1.508l.115-.92-.249-6.9-.014-.377q.131-.05.27-.093c.07-.022.14-.043.212-.062l.1-.033.614-.2,3.733-.653a22.381,22.381,0,0,1,2.978.38c1.357.231,1.893,1.791,3.974-.08l0,0,3.524,1.209.67.23.863.3a.781.781,0,0,1,.087.062,24.1,24.1,0,0,0-1.533,4.958,24.39,24.39,0,0,0-.444,5.847Z",
    transform: "translate(-3445.347 -2565.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241425",
    "data-name": "Path 241425",
    d: "M3561.5,2371.029s2.531-.121,4.227,4.015a12.581,12.581,0,0,1,.912,4.247c.167,3.978-.338,12.992-9.132,7.264,0,0,3.135-2.316,2.218-7.794,0,0-2.81-1.8-2.091-3.358C3557.63,2375.4,3557.883,2370.585,3561.5,2371.029Z",
    transform: "translate(-3535.151 -2371)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11127",
    "data-name": "Ellipse 11127",
    cx: 1.053,
    cy: 0.683,
    rx: 1.053,
    ry: 0.683,
    transform: "translate(23.599 8.893) rotate(-76.816)",
    fill: "#db965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241426",
    "data-name": "Path 241426",
    d: "M3547.623,2377.085s-.19-.317-1.077-2.218c0,0,1.584-3.865,4.563-3.612C3553.637,2371.471,3547.623,2377.085,3547.623,2377.085Z",
    transform: "translate(-3524.954 -2371.227)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeBoard);
export default __webpack_public_path__ + "static/media/notice-board.105f9fa29e2d226ef779c551a7b0b233.svg";
export { ForwardRef as ReactComponent };